<template>
    <div class="news-item">
        <div class="comment_box">
            <div class="date">
                <div class="value">{{ data.created }}</div>
                <div class="arrow_date"></div>
            </div>
            <div class="comments_number">0</div>
        </div>
        <div class="news-content">
            <router-link :to="routePath" class="news-image">
                <img :src="data.photo.crop" alt="img">
            </router-link>
            <router-link tag="div" :to="routePath" class="news-title">
                {{ data.title }}
            </router-link>
            <div v-html="data.short_description" class="news-desc"/>
            <router-link tag="div" :to="routePath" class="more-detail">
                Подробнее →
            </router-link>
            <ul class="routes">
                <li :key="tag.id" v-for="tag in data.tags">
                    <a :href="tag.url">{{ tag.title }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: ["data", "isOffer"],
    name: "news-article",
    computed: {
        routePath() {
            return this.isOffer ? {
                name: this.data.is_special ? 'specialPrograms' : 'offerDetail',
                params: {title: this.data.slug}
            } : {
                name: 'articleDetail',
                params: {title: this.data.slug}
            }
        }
    }
}
</script>

<style scoped>
/* news*/
.news-item {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    width: 45%;
    padding-bottom: 25px;
    border-bottom: 1px solid #E0E0E0;
}

.news-image img {
    width: 100%;
    cursor: pointer;
}

.comment_box .date .value {
    text-transform: uppercase;
    background-color: #006688;
    color: #fff;
    padding: 10px 13px;
    font-size: 12px;
    width: auto;
}

.comment_box .comments_number {
    width: auto;
    margin-left: 2px;
    background-color: #00b6cc;
    padding: 10px 12px;
    color: #fff;
    font-size: 12px;
}

.comment_box .arrow_date {
    content: '';
    left: 0;
    right: auto;
    display: inline;
    border-color: #006688 transparent;
    visibility: visible;
    position: absolute;
    border-style: solid;
    border-width: 5px 5px 0 0;
}

.comment_box {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    position: relative;
}

.news-content .news-title {
    margin: 12px 0;
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    padding-right: 20px;
    cursor: pointer;
}

.news-content .news-title:hover {
    text-decoration: underline;
}

.news-content .news-desc {
    text-align: left;
    font-size: 14px;
    overflow: hidden;
}

.news-content .more-detail {
    color: #006688;
    cursor: pointer;
    font-weight: bold;
    width: fit-content;
    border-bottom: 1px dotted #006688;
    font-size: 12px;
    text-align: left;
    margin: 4px 0;
}

.routes {
    display: flex;
    margin-top: 20px;
    flex-wrap: wrap;
}

.routes li {
    font-size: 11px;
    color: #909090;
    margin-right: 5px;
}

.routes li a {
    color: #909090;
    text-decoration: underline;
    white-space: nowrap;
}

.routes li:last-child {
    margin-right: 0;
}
</style>
